export default {
  text: 'La carte est fournie par Google. Son chargement envoie votre adresse IP à Google.',
  buttons: {
    show_map: 'Afficher la carte',
    retry: 'Réessayer',
  },
  errors: {
    map_unavailable: 'Impossible de charger la carte.',
  },
};
